import React from 'react';
import {useLocation, useLoaderData} from '@remix-run/react';

//components
import Container from 'components/Container';
import BlogListingBreadcrumb from './BlogListingBreadcrumb';
import Blogs from './Blogs';
import BlogListingSidebar from './BlogListingSidebar';
import BlogListingFetch from './BlogListingFetch';

//domains
import type {
  SanityDocBlog,
  SanityBlogTag,
  SanityBlogCategory,
} from 'domains/blog';

interface Props {
  blogs: SanityDocBlog[];
  totalBlogs: number;
  recentBlogs: SanityDocBlog[];
  tags: SanityBlogTag[];
  categories: SanityBlogCategory[];
  blogSettings: {
    blogs_label: string;
    categories_label: string;
    tags_label: string;
    recent_posts_label: string;
  };
  currentTag: SanityBlogTag | null;
  currentCategory: SanityBlogCategory | null;
}

export default function BlogListing({
  blogs,
  tags,
  categories,
  blogSettings,
  currentTag,
  currentCategory,
  recentBlogs,
  totalBlogs,
}: Props) {
  return (
    <div className="pb-20 md:pb-0">
      <Container>
        <BlogListingBreadcrumb
          blogSettings={blogSettings}
          currentTag={currentTag}
          currentCategory={currentCategory}
        />
        <section className="section--blogs">
          <div className="grid gap-8 md:grid-cols-3">
            <Blogs blogs={blogs} />
            {totalBlogs && totalBlogs > 5 ? (
              <div className="md:hidden">
                <BlogListingFetch totalBlogs={totalBlogs} />
              </div>
            ) : null}
            <BlogListingSidebar
              tags={tags}
              categories={categories}
              blogSettings={blogSettings}
              recentBlogs={recentBlogs}
            />
          </div>
          {totalBlogs && totalBlogs > 7 ? (
            <div className="hidden md:block">
              <BlogListingFetch totalBlogs={totalBlogs} />
            </div>
          ) : null}
        </section>
      </Container>
    </div>
  );
}
